import { ReasonUpdateForm } from 'components/Pages/ReverseLogistics/Configuration/Reasons';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const ReasonUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/logistica-reversa/motivos');
  }, [navigate]);

  return (
    <Scaffold>
      <ReasonUpdateForm reasonId={id} onUpdate={onUpdate} />
    </Scaffold>
  );
};
